/**
 * Theme scroll reveals (GSAP + ScrollTrigger).
 * Respects prefers-reduced-motion; skips hero slideshow; refreshes on section editor events.
 */
(function () {
  'use strict';

  function prefersReducedMotion() {
    try {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {
      return true;
    }
  }

  function init() {
    var gsap = window.gsap;
    var ScrollTrigger = window.ScrollTrigger;
    if (!gsap || !ScrollTrigger) return;

    if (prefersReducedMotion()) {
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    var designMode = Boolean(window.Shopify && window.Shopify.designMode);
    var easeOut = 'power3.out';
    var easeSoft = 'power2.out';

    function shouldSkipSection(section) {
      if (!section || !section.querySelector) return true;
      if (section.querySelector('slideshow-component')) return true;
      if (section.querySelector('.slideshow-section')) return true;
      return false;
    }

    function sectionHasProductGrid(section) {
      return Boolean(section.querySelector('.product-grid .product-card, .section-resource-list .product-card'));
    }

    var main = document.getElementById('MainContent');
    if (main) {
      var sections = gsap.utils.toArray(main.querySelectorAll(':scope > .shopify-section'));
      sections.forEach(function (section) {
        if (shouldSkipSection(section)) return;

        /* Grids: stagger cards only (avoids fading the whole grid then cards again) */
        if (sectionHasProductGrid(section)) {
          var cards = section.querySelectorAll('.product-grid .product-card, .section-resource-list .product-card');
          if (cards.length && cards.length <= 28) {
            ScrollTrigger.batch(cards, {
              start: 'top 91%',
              once: true,
              onEnter: function (batch) {
                gsap.from(batch, {
                  y: 24,
                  autoAlpha: 0,
                  duration: designMode ? 0.35 : 0.52,
                  stagger: 0.04,
                  ease: easeSoft,
                  overwrite: 'auto',
                });
              },
            });
          }
          return;
        }

        var target = section.querySelector('.section') || section;
        gsap.from(target, {
          y: 40,
          autoAlpha: 0,
          duration: designMode ? 0.35 : 0.78,
          ease: easeOut,
          scrollTrigger: {
            trigger: section,
            start: 'top 89%',
            end: 'top 55%',
            toggleActions: 'play none none none',
            once: true,
          },
        });
      });
    }

    /* Footer */
    var footer = document.querySelector('footer');
    if (footer) {
      var footerSections = gsap.utils.toArray(footer.querySelectorAll('.shopify-section'));
      if (footerSections.length) {
        gsap.from(footerSections, {
          y: 32,
          autoAlpha: 0,
          duration: 0.65,
          stagger: 0.1,
          ease: easeOut,
          scrollTrigger: {
            trigger: footer,
            start: 'top 92%',
            once: true,
          },
        });
      }
    }

    function refreshScrollTrigger() {
      ScrollTrigger.refresh();
    }

    document.addEventListener('shopify:section:load', refreshScrollTrigger);
    document.addEventListener('shopify:section:reorder', refreshScrollTrigger);
    document.addEventListener('shopify:block:select', refreshScrollTrigger);

    window.addEventListener(
      'resize',
      function () {
        refreshScrollTrigger();
      },
      { passive: true }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
